<section class="bg-shl-light py-24 dark:bg-shl-dark border-t border-gray-200 dark:border-gray-800">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <h2 class="mb-12 text-3xl font-black text-shl-navy dark:text-white text-center">
      {{ 'testimonials.title' | translate }}
    </h2>
    <div class="grid gap-8 md:grid-cols-3">
      @for (item of testimonials; track item.name) {
        <div
          class="rounded-2xl rounded-se-[30px] bg-white p-8 shadow-sm dark:bg-shl-navy border border-gray-100 dark:border-gray-800 flex flex-col justify-between"
        >
          <div>
            <div class="flex text-yellow-400 mb-4">
              @for (star of item.stars; track $index) {
                <mat-icon fontSet="material-symbols-outlined" class="text-lg">{{ star }}</mat-icon>
              }
            </div>
            <p class="text-gray-600 dark:text-gray-300 italic mb-6">{{ item.quote | translate }}</p>
          </div>
          <div class="flex items-center gap-4">
            <div class="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center font-bold text-gray-600">
              {{ item.initials }}
            </div>
            <div>
              <h4 class="font-bold text-shl-navy dark:text-white text-sm">{{ item.name }}</h4>
              <div class="flex items-center gap-2 mt-1">
                <span class="text-xs text-gray-500">{{ item.role | translate }}</span>
                <span class="flex gap-1 text-sm">{{ 'testimonials.route_label' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>
